import Trending from "../../../../src/mdx/api/endpoints/trending.mdx";
import * as React from 'react';
export default {
  Trending,
  React
};